import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import { supabase } from "./supabase";

const provinces = ["Gauteng", "Western Cape", "KwaZulu-Natal", "Eastern Cape", "Limpopo", "Mpumalanga", "North West", "Free State", "Northern Cape"];

const inputStyle = {
  width: "100%",
  background: "#F5F0E8",
  border: "1.5px solid #EDE8DF",
  borderRadius: 8,
  padding: "11px 14px",
  color: "#1A1A2E",
  fontSize: 16,
  fontFamily: "var(--font-body)",
  outline: "none",
  marginBottom: 16,
  boxSizing: "border-box",
};

const labelStyle = {
  fontSize: 11,
  color: "#888",
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  marginBottom: 6,
  display: "block",
};

export default function Testimony() {
  const [showForm, setShowForm] = useState(false);
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ name: "", province: "", project: "", story: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [userTestimonies, setUserTestimonies] = useState([]);
  const [approvedTestimonies, setApprovedTestimonies] = useState([]);

  useEffect(() => {
    fetchApprovedTestimonies();
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (user) {
        setUser(user);
        const firstName = user.user_metadata?.first_name || "";
        const lastName = user.user_metadata?.last_name || "";
        const province = user.user_metadata?.province || "";
        setForm(prev => ({ ...prev, name: `${firstName} ${lastName}`.trim(), province }));
        fetchUserTestimonies(user.id);
      }
    });
  }, []);

  const fetchApprovedTestimonies = async () => {
    const { data } = await supabase.from("testimonies").select("*").eq("approved", true).order("created_at", { ascending: false });
    if (data) setApprovedTestimonies(data);
  };

  const fetchUserTestimonies = async (userId) => {
    const { data } = await supabase.from("testimonies").select("*").eq("user_id", userId);
    if (data) setUserTestimonies(data);
  };

  const handleSubmit = async () => {
    if (!form.name || !form.province || !form.project || !form.story) {
      setError("Please fill in all fields.");
      return;
    }
    if (form.story.length < 30) {
      setError("Please write at least 30 characters.");
      return;
    }
    setLoading(true);
    setError("");
    const { error: submitError } = await supabase.from("testimonies").insert({
      user_id: user?.id || null,
      name: form.name,
      province: form.province,
      project: form.project,
      story: form.story,
    });
    setLoading(false);
    if (submitError) {
      setError(submitError.message);
    } else {
      setSuccess(true);
      setShowForm(false);
      if (user) fetchUserTestimonies(user.id);
    }
  };

  const ownPending = userTestimonies.filter((t) => !t.approved).map((t) => ({ ...t, isNew: true }));
  const displayList = [...ownPending, ...approvedTestimonies];

  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>

      <style>{`
        .test-header { padding: 56px 48px 48px; }
        .test-success { max-width: 600px; margin: 32px auto 0; padding: 16px 24px; }
        .test-form-wrap { max-width: 600px; margin: 40px auto 0; padding: 0 48px; }
        .test-form { background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 32px; }
        .test-grid-wrap { max-width: 1100px; margin: 0 auto; padding: 48px 48px 72px; }
        .test-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
        .test-empty { max-width: 480px; margin: 0 auto; background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 48px 32px; text-align: center; }
        .test-cta { padding: 64px 48px; }
        @media (max-width: 1024px) {
          .test-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 768px) {
          .test-header { padding: 36px 20px 32px; }
          .test-success { margin: 20px 20px 0; }
          .test-form-wrap { padding: 0 20px; margin-top: 24px; }
          .test-form { padding: 20px; }
          .test-grid-wrap { padding: 32px 20px 48px; }
          .test-grid { grid-template-columns: 1fr; gap: 14px; }
          .test-empty { padding: 36px 24px; }
          .test-cta { padding: 48px 20px; }
          .test-cta button { width: 100%; }
        }
      `}</style>

      <Navbar active="Testimony" />

      {/* HEADER */}
      <div className="test-header" style={{ background: "#fff", borderBottom: "1px solid #EDE8DF", textAlign: "center" }}>
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Real Stories
        </div>
        <h1 style={{ fontSize: "clamp(26px, 4vw, 44px)", fontWeight: 900, color: "#1A1A2E", letterSpacing: "-0.02em", margin: "0 0 16px", lineHeight: 1.1 }}>
          Lives Changed by <span style={{ color: "#1B3A6B" }}>Forge SA</span>
        </h1>
        <p style={{ fontSize: 15, color: "#888", lineHeight: 1.8, marginBottom: 28, maxWidth: 540, margin: "0 auto 28px" }}>
          These are not statistics. These are real South Africans whose lives were changed by collective action.
        </p>
        <button
          onClick={() => user ? setShowForm(!showForm) : window.location.href = "/login"}
          style={{ background: "#1B3A6B", border: "none", borderRadius: 99, padding: "13px 28px", color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}
        >
          {showForm ? "Cancel" : "Share Your Story"}
        </button>
      </div>

      {/* SUCCESS */}
      {success && (
        <div className="test-success" style={{ background: "rgba(46,125,50,0.07)", border: "1px solid rgba(46,125,50,0.2)", borderRadius: 12, textAlign: "center", color: "#2E7D32", fontWeight: 700 }}>
          Thank you! Your story has been submitted and is under review.
        </div>
      )}

      {/* FORM */}
      {showForm && (
        <div className="test-form-wrap">
          <div className="test-form">
            <div style={{ fontSize: 18, fontWeight: 800, color: "#1A1A2E", marginBottom: 24 }}>Share Your Story</div>

            <label style={labelStyle}>Your Name</label>
            <input style={inputStyle} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Full name" />

            <label style={labelStyle}>Province</label>
            <select style={inputStyle} value={form.province} onChange={(e) => setForm({ ...form, province: e.target.value })}>
              <option value="">Select province</option>
              {provinces.map(p => <option key={p} value={p}>{p}</option>)}
            </select>

            <label style={labelStyle}>Related Project</label>
            <input style={inputStyle} value={form.project} onChange={(e) => setForm({ ...form, project: e.target.value })} placeholder="e.g. Graduate Connect" />

            <label style={labelStyle}>Your Story</label>
            <textarea
              style={{ ...inputStyle, resize: "vertical" }}
              value={form.story}
              onChange={(e) => setForm({ ...form, story: e.target.value })}
              placeholder="Tell us how Forge SA impacted your life..."
              rows={5}
            />
            <div style={{ fontSize: 11, color: "#888", marginTop: -12, marginBottom: 16 }}>{form.story.length} characters</div>

            {error && (
              <div style={{ background: "rgba(192,57,43,0.07)", border: "1px solid rgba(192,57,43,0.2)", borderRadius: 8, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "#C0392B" }}>
                {error}
              </div>
            )}

            <button
              onClick={handleSubmit}
              disabled={loading}
              style={{ width: "100%", background: loading ? "#EDE8DF" : "#1B3A6B", border: "none", borderRadius: 99, padding: "14px", color: loading ? "#888" : "#fff", fontWeight: 800, fontSize: 15, cursor: loading ? "not-allowed" : "pointer", fontFamily: "var(--font-body)" }}
            >
              {loading ? "Submitting..." : "Submit My Story"}
            </button>
          </div>
        </div>
      )}

      {/* GRID */}
      <div className="test-grid-wrap">
        {displayList.length === 0 ? (
          <div className="test-empty">
            <div style={{ width: 52, height: 52, background: "#F5F0E8", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
              </svg>
            </div>
            <h2 style={{ fontSize: 18, fontWeight: 900, color: "#1A1A2E", marginBottom: 8 }}>
              The first stories are still being written
            </h2>
            <p style={{ fontSize: 13, color: "#888", lineHeight: 1.7 }}>
              As soon as real South Africans start building with Forge SA, their stories will appear here. Be the first to share yours.
            </p>
          </div>
        ) : (
          <div className="test-grid">
            {displayList.map((t, i) => (
              <div key={i} style={{ background: "#fff", border: `1px solid ${t.isNew ? "rgba(27,58,107,0.3)" : "#EDE8DF"}`, borderRadius: 16, padding: 28, display: "flex", flexDirection: "column", gap: 14 }}>
                {t.isNew && (
                  <div style={{ fontSize: 11, color: "#C9A84C", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                    Pending Review
                  </div>
                )}
                <div style={{ width: 44, height: 44, borderRadius: 12, background: "#F5F0E8", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
                  </svg>
                </div>
                <div style={{ fontSize: 13, color: "#4A4A6A", lineHeight: 1.75, flex: 1, fontStyle: "italic" }}>
                  "{t.story}"
                </div>
                <div style={{ borderTop: "1px solid #EDE8DF", paddingTop: 14 }}>
                  <div style={{ fontSize: 14, fontWeight: 800, color: "#1A1A2E", marginBottom: 3 }}>{t.name}</div>
                  <div style={{ fontSize: 12, color: "#888", marginBottom: 8 }}>{t.province}</div>
                  <span style={{ display: "inline-block", background: "#B8D4E8", color: "#1B3A6B", borderRadius: 99, padding: "3px 12px", fontSize: 11, fontWeight: 700 }}>
                    {t.project}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* CTA */}
      <section className="test-cta" style={{ background: "#1B3A6B", textAlign: "center" }}>
        <h2 style={{ fontSize: "clamp(24px, 4vw, 40px)", fontWeight: 900, color: "#fff", margin: "0 0 14px", letterSpacing: "-0.02em" }}>
          Your Story Could Be <span style={{ color: "#C9A84C" }}>Next</span>
        </h2>
        <p style={{ color: "rgba(184,212,232,0.8)", fontSize: 15, marginBottom: 28 }}>
          Join the South Africans who are building the future, together.
        </p>
        <button
          onClick={() => window.location.href = "/register"}
          style={{ background: "#C9A84C", border: "none", borderRadius: 99, padding: "14px 36px", color: "#fff", fontWeight: 700, fontSize: 15, cursor: "pointer", fontFamily: "var(--font-body)" }}
        >
          Join the Movement
        </button>
        <div style={{ marginTop: 32, fontSize: 12, color: "rgba(184,212,232,0.35)" }}>
          Forge SA. Built by us. For us.
        </div>
      </section>

    </div>
  );
}